module.exports = __webpack_public_path__ + "assets/img/solution.c59f5dbd.png";